export const styles = {
  instanceCell: 'tw-flex tw-flex-col tw-gap-0.5',
  instanceName: 'tw-font-medium tw-text-neutral-900 tw-text-sm',
  instanceId: 'tw-text-xs tw-text-neutral-400 tw-font-mono',
  name: 'tw-text-neutral-700 tw-text-sm',
  pimsText: 'tw-text-neutral-600 tw-text-sm',
};
